import { takeEvery, put, call, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
//IMPORT ACTION TYPES
import {
  CREATE_TEST_REQUEST,
  CREATE_TEST_SUCCESS,
  CREATE_TEST_FAIL,
  GET_TEST_DETAIL_REQUEST,
  GET_TEST_DETAIL_SUCCESS,
  GET_TEST_DETAIL_FAIL,
  DELETE_TEST_REQUEST,
  DELETE_TEST_SUCCESS,
  DELETE_TEST_FAIL,
  UPDATE_TEST_REQUEST,
  UPDATE_TEST_SUCCESS,
  UPDATE_TEST_FAIL,
  GET_TESTS_LIST_REQUEST,
  GET_TESTS_LIST_SUCCESS,
  GET_TESTS_LIST_FAIL,
} from "./actionTypes";

// IMPORT ACTIONS
import {
  createTestRequest,
  createTestSuccess,
  createTestFail,
} from "./actions";
import {
  getTestsListRequest,
  getTestsListSuccess,
  getTestsListFail,
} from "./actions";
import {
  updateTestRequest,
  updateTestSuccess,
  updateTestFail,
} from "./actions";
import {
  deleteTestRequest,
  deleteTestSuccess,
  deleteTestFail,
} from "./actions";
import {
  getTestDetailRequest,
  getTestDetailSuccess,
  getTestDetailFail,
} from "./actions";

import axios from "axios";
import TestsList from "pages/Tests/TestsList";
import { url } from "APIs/URLS";

const CreateTestAPICall = async test => {
  const promise = axios.post(`${url}/Inventory/CreateTest`, test);
  // {
  //   Title: test.Title,
  //   Description: test.Description,
  //   PreConditions: test.PreConditions,
  //   LowerPriceLimit: test.LowerPriceLimit,
  //   UpperPriceLimit: test.UpperPriceLimit,
  //   AvgDuration: test.AvgDuration,
  // }
  // );
  try {
    toast.promise(promise, {
      loading: "Creating Test...",
      success: "Test Created Successfully",
      error: "Error Creating Test",
    });
    const response = await promise;
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* createTest({ payload: test }) {
  try {
    const response = yield call(CreateTestAPICall, test);
    console.log(typeof response);
    // put causes the action to be dispatched to the store
    // this action is then handled by the reducer
    // the reducer then updates the state
    // the state is then rendered to the screen
    // the screen is updated with the new state
    // This Action should not be watched by the saga
    yield put(createTestSuccess(response));
    // history.push("/testslist"); // redirect to testlist screen
    window.location.href = "/testslist";
  } catch (error) {
    console.log(error);
    yield put(createTestFail(error));
  }
}

//TEST LIST
const TestListAPICall = async () => {
  try {
    const response = await axios.get(`${url}/Inventory/ViewTests`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);

    throw error;
  }
};
function* getTestsList() {
  try {
    const response = yield call(TestListAPICall);
    console.log("data = " + response);
    yield put(getTestsListSuccess(response));
  } catch (error) {
    console.log("error = " + error);
    yield put(getTestsListFail(error));
  }
}
//DELETE TEST

const DeleteTestAPICall = async test => {
  const myCall = axios.delete(`${url}/Inventory/DeleteTest/${test.id}`);
  try {
    toast.promise(myCall, {
      loading: "Deleting Test...",
      success: "Test Deleted Successfully",
      error: "Error Deleting Test",
    });
    const response = await myCall;
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onDeleteTest({ payload: test }) {
  try {
    const response = yield call(DeleteTestAPICall, test);
    console.log("delete data = " + response);
    yield put(deleteTestSuccess(response));
  } catch (error) {
    yield put(deleteTestFail(error));
  }
}
//UPDATE

const UpdateTestAPICall = async (test, id) => {
  console.log("test passed", test);
  console.log("id passed", id);
  const promise = axios.put(`${url}/Inventory/UpdateTest/${id}`, test);
  console.log("promise = " + promise);
  try {
    toast.promise(promise, {
      loading: "Updating Test...",
      success: "Test Updated Successfully",
      error: "Error Updating Test",
    });
    const response = await promise;
    console.log("reponse=await promise", response);
    console.log("reponse.data", response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* onUpdateTest({ payload: { test, id } }) {
  try {
    const response = yield call(UpdateTestAPICall, test, id);
    console.log("Update data = " + response);
    yield put(updateTestSuccess(response));
  } catch (error) {
    yield put(updateTestFail(error));
  }
}

const TestDetailAPICall = async id => {
  try {
    const response = await axios.get(`${url}/Inventory/TestDetail/${id}`);
    console.log("data = " + response.data);
    return response.data;
  } catch (error) {
    console.log("error = " + error);
    throw error;
  }
};

function* ongetTestDetail({ payload: id }) {
  try {
    const response = yield call(TestDetailAPICall, id);
    yield put(getTestDetailSuccess(response));
  } catch (error) {
    yield put(getTestDetailFail(error));
  }
}

function* TestSaga() {
  yield takeEvery(CREATE_TEST_REQUEST, createTest);
  yield takeEvery(GET_TESTS_LIST_REQUEST, getTestsList);
  yield takeEvery(UPDATE_TEST_REQUEST, onUpdateTest);
  yield takeEvery(DELETE_TEST_REQUEST, onDeleteTest);
  yield takeEvery(GET_TEST_DETAIL_REQUEST, ongetTestDetail);
}

export default TestSaga;
